import React from 'react';

import ProgressBar from '@atlaskit/progress-bar/progress-bar';

const ProgressBarDefaultExample = (): React.JSX.Element => {
	return <ProgressBar ariaLabel="Done: 3 of 10 work items" value={0.3} />;
};

export default ProgressBarDefaultExample;
